/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  var currencyCode = Shopify.currency.active;
  var currencyFlag = document.getElementById('currencyFlag');

  if (currencyFlag) {
    if (currencyCode === 'CAD') {
      currencyFlag.src = 'https://cdn.shopify.com/s/files/1/0427/8409/6410/files/64px-Flag_of_Canada_svg.png?v=1716826272';
      currencyFlag.alt = 'Canadian Flag';
    } else if (currencyCode === 'USD') {
      currencyFlag.src = 'https://cdn.shopify.com/s/files/1/0427/8409/6410/files/64px-Flag_of_the_United_States_svg.png?v=1716826272';
      currencyFlag.alt = 'USA Flag';
    }
  }

  // Define the market URL segments
  const marketSegments = {
    'Canada': '', // No segment for the primary market
    'USA': '/en-us',
    'International': '/en-global'
  };

  // Determine the current market based on the pathname
  let currentMarket = 'Canada'; // Default market
  if (window.location.pathname.includes('/en-us')) {
    currentMarket = 'USA';
  } else if (window.location.pathname.includes('/en-global')) {
    currentMarket = 'International';
  }

  // Get the URL segment for the current market
  const urlSegment = marketSegments[currentMarket];

  // Modify the links in the widget after a slight delay to ensure the widget has loaded
  setTimeout(function() {
    const productLinks = document.querySelectorAll('.th_pb_innercode .th_product_img a, .th_pb_innercode .th_pb_pro_title a');
    productLinks.forEach(function (link) {
      const originalHref = link.getAttribute('href');
      if (!originalHref.startsWith(urlSegment) && !originalHref.startsWith('http')) {
        link.href = urlSegment + originalHref;
      }
    });
  }, 2000); // Adjust the delay if necessary

        // open the newsletter signup bar open if form is submitted to show the status
        curr_url = new URL(window.location.href);
		if (curr_url.searchParams.has('customer_posted')) {
			setTimeout(function() {
              var button_annc = document.querySelector('button.announcement-bar__button.hidden-phone');
              var annc_bar = document.querySelector('#announcement-bar-newsletter');
              annc_bar.style.height = "auto";
              annc_bar.style.visibility = "visible";
              // button_annc.click(); 
              // console.log('clicked');
              // button_annc.classList.add("mystyle");
            }, 2000);
		} else {
			// console.log('not found');
		}

  
});

// Prevent redirecting to Cart page after product is added.
document.addEventListener('DOMContentLoaded', function () {
    // Listen for all 'add to cart' form submissions
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault(); // Prevent default form submission

            let formData = new FormData(form);
            
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            .then(response => response.json())
            .then(data => {
                // Product has been successfully added, now refresh the page
                window.location.reload();
                
            })
            .catch(error => console.error('Error adding product:', error));
        });
    });
});
